// page-positions.jsx — /recruit/positions/ 募集職種の一覧
// 求人票は CPT `job_posting` が正本。PHP 側（page-positions.php）が
// window.HB_JOBS に注入する。ここでは表示だけを担当する。
//
// 親Issue: #131 /recruit/ 以下の拡充
// - Wantedly URL が無い求人も落とさない。応募導線は /contact/?type=recruit
// - 詳細ページは持たない（求人の中身は Wantedly 側が正本）

(function(){
  const { HBLayout, HBSubHero, hbcp, fontEN, fontENSans, fontJP, fontMono, HB_BASE, HB_WANTEDLY } = window;

  const JOBS = Array.isArray(window.HB_JOBS) ? window.HB_JOBS : [];

  // 部門タグごとの色。求人票マスタで実際に使っている 5 種を持ち、未知の部門は既定色に落とす
  const DEPT_COLOR = {
    DX:       hbcp.blue,
    FINANCE:  '#1A4D4D',
    AI:       '#5C2B45',
    CORP:     '#8A6A2F',
    INTERN:   '#3F5B7A',
  };
  const deptColor = (d) => DEPT_COLOR[String(d || '').toUpperCase()] || hbcp.ink;

  function JobCard({ job }) {
    const meta = [job.employment, job.location].filter(Boolean).join(' ／ ');
    const c = deptColor(job.dept);
    return (
      <a
        href={job.url}
        {...(job.external ? { target:'_blank', rel:'noopener' } : {})}
        style={{
          display:'flex', flexDirection:'column', gap:10,
          padding:'28px 26px 24px', background:'#fff',
          border:'1px solid '+hbcp.line, borderRadius:12,
          textDecoration:'none', color:hbcp.ink,
          transition:'transform .2s, box-shadow .2s',
        }}
        onMouseEnter={e=>{ e.currentTarget.style.transform='translateY(-2px)'; e.currentTarget.style.boxShadow='0 8px 24px rgba(10,40,70,.10)'; }}
        onMouseLeave={e=>{ e.currentTarget.style.transform='none'; e.currentTarget.style.boxShadow='none'; }}
      >
        {job.dept ? (
          <span style={{
            alignSelf:'flex-start', border:'1px solid '+c, color:c, borderRadius:4,
            fontFamily:fontMono, fontSize:10.5, fontWeight:700, letterSpacing:'.14em',
            padding:'2px 10px',
          }}>{job.dept}</span>
        ) : null}

        <h2 style={{margin:0, fontFamily:fontJP, fontSize:17, fontWeight:700, lineHeight:1.55, letterSpacing:'.04em', color:hbcp.ink}}>
          {job.title}
        </h2>

        {meta ? (
          <p style={{margin:0, fontFamily:fontJP, fontSize:12, letterSpacing:'.04em', color:hbcp.inkLight}}>{meta}</p>
        ) : null}

        {job.lead ? (
          <p style={{margin:'2px 0 0', fontFamily:fontJP, fontSize:13, lineHeight:1.85, color:hbcp.inkSoft, flex:1}}>{job.lead}</p>
        ) : null}

        <span style={{
          marginTop:12, display:'inline-flex', alignItems:'center', gap:8,
          fontFamily:fontJP, fontSize:13, fontWeight:700, letterSpacing:'.04em', color:hbcp.blue,
        }}>
          {job.external ? 'Wantedly で詳しく見る' : 'この職種について相談する'}
          <em style={{fontStyle:'normal', fontFamily:fontEN}}>{job.external ? '↗' : '→'}</em>
        </span>
      </a>
    );
  }

  function RecruitPositionsPage() {
    return (
      <HBLayout>
        <HBSubHero
          crumb={'Recruit / 募集職種'}
          en="Positions"
          jp={<span>いま、<span style={{color:hbcp.blue}}>一緒に働きたい</span>人たち</span>}
          tag={'Open positions.'}
          lead={'会計・DX・AI・編集の各領域でメンバーを募集しています。応募を決めていなくて構いません。話を聞くだけでも歓迎です。'}
        />

        <section style={{padding:'72px 24px', background:hbcp.paper}}>
          <div style={{maxWidth:1040, margin:'0 auto'}}>
            <div style={{display:'flex', alignItems:'baseline', gap:16, borderBottom:'1px solid '+hbcp.line, paddingBottom:16, marginBottom:36}}>
              <span style={{fontFamily:fontMono, fontSize:11, letterSpacing:'.26em', fontWeight:700, color:hbcp.ink}}>OPEN POSITIONS</span>
              <span style={{fontFamily:fontJP, fontSize:18, fontWeight:700, letterSpacing:'.06em', color:hbcp.ink}}>募集中の職種</span>
              <span style={{marginLeft:'auto', fontFamily:fontMono, fontSize:11, color:hbcp.inkLight}}>{JOBS.length} ROLES</span>
            </div>

            {JOBS.length ? (
              <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(280px, 1fr))', gap:20}}>
                {JOBS.map(j => <JobCard key={j.id} job={j} />)}
              </div>
            ) : (
              <p style={{fontFamily:fontJP, fontSize:14, lineHeight:1.95, color:hbcp.inkSoft, margin:0}}>
                現在、公開中の募集はありません。今後の募集についてお知りになりたい方は、
                <a href={`${HB_BASE}/contact/?type=recruit`} style={{color:hbcp.blue}}>お問い合わせ</a>
                からご連絡ください。
              </p>
            )}

            <p style={{margin:'28px 0 0', fontFamily:fontJP, fontSize:12.5, lineHeight:1.9, color:hbcp.inkLight}}>
              募集職種に当てはまらない場合でも、お気軽にご相談ください。業務委託・フリーランスとしての案件をお探しの方は
              <a href="https://pro.hatenabase.jp/" target="_blank" rel="noopener" style={{color:hbcp.blue}}> Hatenabase Pro </a>
              をご覧ください。
            </p>
          </div>
        </section>

        <section style={{padding:'72px 24px', background:hbcp.ink, color:'#fff'}}>
          <div style={{maxWidth:1040, margin:'0 auto', display:'grid', gridTemplateColumns:'1fr auto', gap:40, alignItems:'center'}}>
            <div>
              <p style={{fontFamily:fontMono, fontSize:11, letterSpacing:'.26em', fontWeight:700, margin:'0 0 12px', opacity:.75}}>NOT SURE YET?</p>
              <h2 style={{fontFamily:fontJP, fontSize:22, fontWeight:700, lineHeight:1.6, letterSpacing:'.06em', margin:'0 0 14px'}}>
                まず、話だけしませんか。
              </h2>
              <p style={{fontFamily:fontJP, fontSize:15, lineHeight:1.95, opacity:.9, margin:0, maxWidth:560}}>
                選考ではありません。転職を決めていない方が大半です。いまのご経験が、会計と AI の市場でどこに効くのかを一緒に整理します。
              </p>
            </div>
            <div style={{display:'grid', gap:14, minWidth:280}}>
              <a href={`${HB_BASE}/contact/?type=recruit`} style={{padding:'18px 28px', background:'#fff', color:hbcp.ink, textDecoration:'none', fontFamily:fontJP, fontSize:15, fontWeight:700, display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                <span>カジュアル面談を申し込む</span><span style={{fontFamily:fontEN}}>→</span>
              </a>
              <a href={HB_WANTEDLY} target="_blank" rel="noopener" style={{padding:'18px 28px', background:'transparent', color:'#fff', border:'1px solid rgba(255,255,255,.6)', textDecoration:'none', fontFamily:fontJP, fontSize:15, fontWeight:600, display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                <span>Wantedly で詳しく見る</span><span style={{fontFamily:fontEN}}>↗</span>
              </a>
            </div>
          </div>
        </section>
      </HBLayout>
    );
  }

  Object.assign(window, { RecruitPositionsPage });
})();
